import { render } from "./postprint.vue?vue&type=template&id=7979d403"
import script from "./postprint.vue?vue&type=script&lang=js"
export * from "./postprint.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__